module.exports = __webpack_public_path__ + "static/media/ExerciseIconScienceBig.7c1c4bd1.svg";